import { apiService } from '@shared/services/apiServices';
import type {
  ListAdminsResponse,
  ListAdminsParams,
} from '@epics/adminManagment/types/adminListType';

export const listAdminApiService = {
  listAdmins: async (
    params?: ListAdminsParams
  ): Promise<ListAdminsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const endpoint = `loopay-user-management/users${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiService.getAPI(endpoint, {
      skipGlobalErrorRedirect: true,
    });

    if (response.error) {
      if (response.status === 403) {
        const err = new Error('Forbidden') as Error & { status: number };
        err.status = 403;
        throw err;
      }
      // 404 or other errors — return empty result (existing behaviour)
      return {
        success: true,
        data: [],
        totalCount: 0,
        page: params?.page || 1,
        limit: params?.limit || 10,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      };
    }

    return response.data as ListAdminsResponse;
  },
};
